export const cuenta = [
  {
    label: "Id",
    name: "idcuenta",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Moneda",
    name: "idmoneda",
    type: "moneda",
    showOnList: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
];
